module.exports = __webpack_public_path__ + "img/p1-plane.a66560a6.png";